import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const polyps: AnswerPathTreeNode = {
  path: 'polyps',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredPolypsDetails }],
};
